import React, { FC } from 'react';

import PropTypes from 'prop-types';

import A from '@adsk/alloy-react-a';
import { displayDate, displayTime } from '@adsk/alloy-react-datetime';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

export interface MaintenanceStateProps {
  name?: string;
  endDate?: Date;
  children?: React.ReactNode;
}

const MaintenanceState: FC<MaintenanceStateProps> = ({
  name,
  endDate,
  children,
}) => {
  const { T, locale } = useLocale(({ locale }) =>
    require(`./i18n/${locale}.json`),
  );

  const description = T.translate(
    endDate
      ? 'MAINTENANCE_DESCRIPTION_WITH_END_DATE'
      : 'MAINTENANCE_DESCRIPTION',
    {
      context: (name ?? '').length,
      name,
      ...(endDate
        ? {
            endTime: displayTime(endDate, { locale }),
            endDate: displayDate(endDate, {
              format: 'numeric',
              locale,
            }),
          }
        : {}),
    },
  );

  return (
    <div
      css={[
        {
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      ]}
    >
      <EmptyState
        size={EmptyState.SIZES.MEDIUM}
        illustrationType={EmptyState.ILLUSTRATION_TYPES.CRANE_CONSTRUCTION}
        title={T.translate('MAINTENANCE_TITLE')}
        description={description}
      >
        {children ?? (
          <A
            style={theme.typography.bodyMedium}
            href="https://health.autodesk.com/"
          >
            {T.translate('MAINTENANCE_DEFAULT_HREF_TEXT')}
          </A>
        )}
      </EmptyState>
    </div>
  );
};

MaintenanceState.displayName = 'MaintenanceState';

MaintenanceState.propTypes = {
  /** The name of the tool being maintained */
  name: PropTypes.string,
  /** The end date to show the maintenance page for */
  endDate: PropTypes.instanceOf(Date),
};

export default MaintenanceState;
